import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { createYupSchema } from 'utils/CreateYupSchema';
import { FormLayout } from 'components/create-form/FormLayout';
import { LAYOUT_ITEM } from 'constants/FormConstants';
import { FormContext } from 'context/FormContext';

interface CreateFormProps {
	fields: any[];
	watchField?: string[];
	resetField?: string;
	customEvent?: (values: any) => void;
	newsValues?: any[];
}

export const CreateFormLayout = ({
	fields,
	resetField,
	watchField,
	customEvent,
	newsValues,
}: CreateFormProps) => {
	const mySchema = createYupSchema(fields);

	const { setValue, getValues, control, formState, watch } = useForm({
		resolver: yupResolver(mySchema),
		mode: 'all',
	});

	const forceUpdate = React.useReducer(() => ({}), {})[1] as () => void;

	const { setError, setData } = useContext(FormContext);

	useEffect(() => {
		if (customEvent !== undefined) {
			customEvent(getValues());
			if (resetField && resetField !== '') {
				setValue(resetField, '', { shouldDirty: true, shouldValidate: true });
			}
			forceUpdate();
		}
	}, [...watch(watchField ? watchField : ['error'])]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		setData(getValues());
		setError(!formState.isValid);
	}, [formState.isValidating, formState.isValid]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		if (newsValues) {
			newsValues.forEach((item) => {
				setValue(item.name, item.value, { shouldValidate: true });
			});
		}
	}, [newsValues]); // eslint-disable-line react-hooks/exhaustive-deps

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>, name: string, type: string) => {
		if (type === LAYOUT_ITEM.TYPE.CHECKBOX) {
			setValue(name, event.target.checked, { shouldDirty: true, shouldValidate: true });
		} else {
			setValue(name, event.target.value, { shouldDirty: true });
		}
		setData(getValues());
	};

	return (
		<form>
			{fields.map((item, index) => (
				<FormLayout
					key={index}
					field={item}
					control={control}
					formState={formState}
					handleChange={handleChange}
				/>
			))}
		</form>
	);
};
